import styled from 'styled-components';
import CenteredLayout from '../../layouts/CenteredLayout';

export const Container = styled(CenteredLayout)`
  width: 100%;
  padding: 0 2rem;
`;
